import { Directive, forwardRef, Input } from '@angular/core';
import { COMPONENT_DEFINITION_REF } from "../../utility/component-definition-token";

@Directive({
    selector: 'threshold',
    providers: [{ provide: COMPONENT_DEFINITION_REF, useExisting: forwardRef(() => ThresholdComponent) }]
})
export class ThresholdComponent {

    @Input() label: string;

    @Input() value: number;

    @Input() color: string;

    @Input() direction: Direction;

    @Input() valueProperty: string;

    @Input() valueMetric: string;

    @Input() aggregation: string;

    @Input() config: any;

    @Input() horizontalLabelAlignment: HorizontalLabelAlignment;

    @Input() verticalLabelAlignment: VerticalLabelAlignment;

}

enum Direction {
    HORIZONTAL = "HORIZONTAL",
    VERTICAL = "VERTICAL"
}

enum HorizontalLabelAlignment {
    LEFT = "LEFT",
    RIGHT = "RIGHT"
}

enum VerticalLabelAlignment {
    TOP = "TOP",
    BOTTOM = "BOTTOM"
}